// İsme özel madlen (sections/cm-madlen-tasarim.liquid): bilgiler, tasarım, paket (adet, sunum), teslim süresi,
// paylaşım ve sepete ekleme. Fiyatlar kargo dahil; adres ve ödeme Shopify ödeme adımında.
// Motifler: cm-madlen-designs.js, 3D: cm-madlen-3d.js (window.cmMadlen üzerinden konuşur).
// Form elemanları Dawn'ın ürün sayfasındaki gibi: pill radyolar, field. "Seçenekler" ve "Sepete ekle" blokları şart.
// Her ürün bir etkinlik (nişan, bebek, kurumsal); varyantları paketler: Tasarım × Adet × Sunum.
(() => {
const root = document.getElementById("cmm-root");
if (!root || !window.cmMadlenTemplates || !document.getElementById("cmm-designs") || !document.getElementById("cmm-finish")) return;

const CFG = JSON.parse(document.getElementById("cmm-config").textContent);
const CM = (window.cmMadlen = window.cmMadlen || {});
CM.assets = CFG.assets;

const $ = id => document.getElementById("cmm-" + id);
const $$ = sel => root.querySelectorAll(sel);
const esc = s => String(s ?? "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const TEMPLATES = window.cmMadlenTemplates;
const tplById = id => TEMPLATES.find(t => t.id === id);
const render = (t, o) => `<svg viewBox="0 0 ${t.w || 300} ${t.h || 300}" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="${esc(t.name)} ön izleme">${t.svg(o)}</svg>`;

// ---- Varyantlar = paketler. Seçenek adları Shopify'dan: "Tasarım", "Adet" ("100 adet"), "Sunum" ("Kutusuz" / "Cam kutu").
// Fiyat varyantın fiyatı (hazırlık, baskı ve kargo dahil). Tasarım SKU'dan: MADLEN-BEYAZGUL-100-KUTU → beyazgul,
// MADLEN-ALTIN-KURUMSAL-150 → altin (son ek aynı tasarımı farklı ürünlerde ayırır). SKU'su tanınmayan varyant gösterilmez.
const optIndex = name => (CFG.options || []).findIndex(o => String(o).toLocaleLowerCase("tr") === name);
const I_DESIGN = optIndex("tasarım"), I_QTY = optIndex("adet"), I_BOX = optIndex("sunum");
const designOf = sku => { const s = String(sku || "").toLowerCase().replace(/^madlen-/, "").replace(/-\d+(-kutu)?$/, ""), base = s.replace(/-[a-z]+$/, "");
  return tplById(s) ? s : tplById(base) ? base : null; };
let VARIANTS = (CFG.productVariants || []).map(v => ({ id: v.id, available: v.available, price: v.price / 100, design: designOf(v.sku),
  title: I_DESIGN >= 0 ? v.options[I_DESIGN] : "", n: I_QTY >= 0 ? parseInt(v.options[I_QTY], 10) || 0 : 0,
  box: I_BOX >= 0 && String(v.options[I_BOX]).toLocaleLowerCase("tr") === "cam kutu" })).filter(v => v.design && v.n);
const designName = id => VARIANTS.find(v => v.design === id && v.title)?.title || tplById(id).name;
// Bebek: isim yazılmazsa etikette seçili tasarımın yazısı ("Hoşgeldin" + "Canım Oğlum/Kızım", cm-madlen-designs.js → fb)
const babyDefault = t => (t || tplById(chosen))?.fb || "bebeğim";
// ---- Kategoriler: alanlar, etiket yazısı (ortak model o.text, cm-madlen-designs.js), sepet satırı, kapak yazısı.
// Ürünün kategorisi "madlen-<kategori>" etiketinden (ör. madlen-kurumsal), yoksa tasarımların asıl kategorisinden.
// Yeni kategori = buraya bir giriş + section'da alan grubu (cmm-f<Grup>).
const splitWords = s => { const w = s.trim().split(/\s+/); return w.length > 1 ? [w[0], w.slice(1).join(" ")] : [s.trim()]; };
const CATS = {
  nisan: { group: "fNisan", fields: { bride: "gelin", groom: "damat", date: "tarih" },
    required: [["bride", "gelin adı"], ["groom", "damat adı"], ["date", "tarih"]],
    text: (f, demo) => { const main = [f.bride || (demo ? "Gelin" : ""), f.groom || (demo ? "Damat" : "")];
      return { kind: "couple", main, full: main.filter(Boolean).join(" & "), date: f.date }; },
    rows: f => [["Çift", `${f.bride || "—"} & ${f.groom || "—"}`], ["Tarih", fmtDate(f.date) || "—"]],
    props: f => ({ "Gelin": f.bride, "Damat": f.groom, "Tarih": fmtDate(f.date) }),
    eventDate: f => f.date },
  bebek: { group: "fBebek", fields: { baby: "bebek", bdate: "dogum" }, required: [],
    text: (f, demo, t) => { const full = f.baby || babyDefault(t); return { kind: "person", main: [full], full, kicker: "Hoşgeldin", date: f.bdate }; },
    rows: f => [["Bebek", f.baby || "İsimsiz"], ["Doğum tarihi", fmtDate(f.bdate) || "—"]],
    props: f => ({ "Bebek": f.baby || "İsimsiz", "Doğum tarihi": fmtDate(f.bdate) }) },
  kurumsal: { group: "fKurumsal", fields: { firm: "firma", msg: "mesaj" }, required: [["firm", "firma adı"]],
    text: (f, demo) => { const full = f.firm || (demo ? "Firma Adı" : ""); return { kind: "company", main: splitWords(full), full, msg: f.msg }; },
    rows: f => [["Firma", f.firm || "—"], ["Mesaj", f.msg || "—"]],
    props: f => ({ "Firma": f.firm, "Mesaj": f.msg }) },
};
const cat = CATS[CFG.category] ? CFG.category : VARIANTS.map(v => tplById(v.design).cat).find(c => CATS[c]) || "nisan";
const C = CATS[cat];
// Paket varyantı yoksa (ör. başka bir ürüne ?view= ile bakılıyorsa) kategorinin tasarımları 100/150/200 adet, fiyatsız ve sipariş kapalı
const PREVIEW_ONLY = !VARIANTS.length;
if (PREVIEW_ONLY) VARIANTS = TEMPLATES.filter(t => t.cat === cat || (t.cat === "*" && !t.logoOnly))
  .flatMap(t => [100, 150, 200].map(n => ({ id: null, available: false, price: 0, design: t.id, title: t.name, n, box: false })));

// ---- Tarihler (YYYY-MM-DD, yerel saat)
const fmtDate = d => { if (!d) return ""; const [y, m, dd] = d.split("-"); return `${dd}.${m}.${y}`; };
const toDate = s => s ? new Date(s + "T12:00") : new Date();
const iso = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const addDays = (s, n) => { const d = toDate(s); d.setDate(d.getDate() + n); return iso(d); };
const workday = s => { const d = toDate(s); while (d.getDay() % 6 === 0) d.setDate(d.getDate() + 1); return iso(d); };   // Cmt/Paz → Pzt
const addWorkDays = (s, n) => { const d = toDate(s); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return iso(d); };
const nice = s => toDate(s).toLocaleDateString("tr-TR", { day: "numeric", month: "long", weekday: "long" });   // 2 Kasım Pazartesi
const niceShort = s => toDate(s).toLocaleDateString("tr-TR", { day: "numeric", month: "long" });


// ---- Paketler: adetler ve kutu Shopify varyantlarından. Süreler, gramaj ve kargo kuralı section ayarlarından.
const QTYS = [...new Set(VARIANTS.map(v => v.n))].sort((a, b) => a - b);
const BOX_OFFERED = VARIANTS.some(v => v.box);
const variantFor = (design, n, box) => VARIANTS.find(v => v.design === design && v.n === n && v.box === box);
// Kargo: mağaza kuralı (sabit ücret, sınırın üstünde ücretsiz). Paket fiyatları kargo dahil.
const SHIP = { flat: (CFG.shipping?.flat || 0) / 100, freeFrom: (CFG.shipping?.freeFrom || 0) / 100 };
const shipFor = price => SHIP.freeFrom && price >= SHIP.freeFrom ? 0 : SHIP.flat;
// Gramaj: 100 adet × 5,5 g = 550 g, 1000 g'dan itibaren kg
const weight = n => { const g = Math.round(n * (+CFG.grams || 0)); if (!g) return "";
  return g >= 1000 ? `${(g / 1000).toLocaleString("tr-TR", { maximumFractionDigits: 2 })} kg` : `${g} g`; };
// Para: mağazanın para biçimi (Shopify yönetici → Ayarlar → Mağaza ayrıntıları), sepet ve ödeme ile aynı görünür
const money = v => { const c = Math.round(v * 100);
  const num = (dec, th, ds) => { const [i, f] = (c / 100).toFixed(dec).split("."); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? ds + f : ""); };
  const F = { amount: [2, ",", "."], amount_no_decimals: [0, ",", "."], amount_with_comma_separator: [2, ".", ","],
    amount_no_decimals_with_comma_separator: [0, ".", ","], amount_with_apostrophe_separator: [2, "'", "."],
    amount_no_decimals_with_space_separator: [0, " ", ","], amount_with_space_separator: [2, " ", ","],
    amount_with_period_and_space_separator: [2, " ", "."] };
  return (CFG.moneyFormat || "{{amount}} TL").replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => num(...(F[k] || F.amount))); };


// Fiyat: seçilen paketin fiyatı; kargo sınırın altındaysa sabit ücret eklenir. Toplam kargo dahil gösterilir.
const pack = o => variantFor(o.design, o.n, o.box);
const price = o => pack(o)?.price ?? 0;
const shipping = o => shipFor(price(o));
const total = o => price(o) + shipping(o);
const unit = o => total(o) / o.n;
const priceLines = o => [
  [`${o.n} adet isme özel madlen${o.box ? " · cam kutulu" : ""}`, money(price(o))],
  ["Kargo", shipping(o) ? money(shipping(o)) : "Dahil"],
];
const TOTAL_LABEL = "Toplam (kargo dahil)";

// ---- Süre: hazırlık (takvim günü) + kargo (iş günü)
const prodDays = () => Math.max(1, CFG.production ?? 10);
const SHIP_DAYS = CFG.shippingDays ?? 3;
const plan = () => { const today = iso(new Date()), shipOn = workday(addDays(today, prodDays()));   // kargo sadece iş günü
  return { today, prodFrom: addDays(today, 1), shipOn, arriveFrom: addWorkDays(shipOn, 1), arriveBy: addWorkDays(shipOn, SHIP_DAYS) }; };
const earliest = () => plan().arriveBy;

// ---- Sipariş ↔ bağlantı (paylaşım linki aynı tasarımı ve paketi açar)
const PARAMS = { design: "tasarim", n: "adet", box: "kutu", need: "ihtiyac", ok: "onay" };
const toParams = o => { const p = new URLSearchParams();
  for (const [k, q] of Object.entries(C.fields)) if (o.f[k]) p.set(q, o.f[k]);
  for (const [k, q] of Object.entries(PARAMS)) { let v = o[k]; if (k === "box") v = v ? "1" : "0";
    if (v !== undefined && v !== null && v !== "") p.set(q, v); }
  return p; };
const fromParams = p => { const o = { f: {} }; for (const [k, q] of Object.entries(PARAMS)) if (p.has(q)) o[k] = p.get(q);
  for (const [k, q] of Object.entries(C.fields)) if (p.has(q)) o.f[k] = p.get(q);
  if ("n" in o) o.n = QTYS.includes(+o.n) ? +o.n : undefined;
  if ("box" in o) o.box = o.box !== "0";
  return o; };
const shareUrl = o => `${location.origin}${location.pathname}?${toParams(o)}`;

// Cam kutu kapağındaki altın yazı (o.text, ön izleme verisiyle)
const lidLines = o => { const t = o.text, sub = t.date ? [{ t: fmtDate(t.date), f: "date" }] : t.msg ? [{ t: t.msg, f: "script" }] : [];
  if (t.kind === "couple") return [{ t: t.main[0], f: "script" }, { t: "&", f: "amp" }, { t: t.main[1], f: "script" }, ...sub];
  if (t.kind === "company") return [{ t: t.full.toLocaleUpperCase("tr"), f: "caps" }, ...sub];
  return [{ t: t.full || "Hoşgeldin bebek", f: "script" }, ...sub]; };

// ---- Durum
const start = fromParams(new URLSearchParams(location.search));
// Satışta olan paketlerin tasarımları (hepsi kapalıysa yine de gösterilir, sipariş kapalı kalır)
const list = () => { const avail = VARIANTS.filter(v => v.available), vs = avail.length ? avail : VARIANTS;
  return [...new Set(vs.map(v => v.design))].map(tplById); };
// Başlangıç: paylaşım linki (?tasarim=&adet=&kutu=), sonra Shopify'ın ?variant= seçimi, sonra ilk paket
const sv = VARIANTS.find(v => v.id && v.id === CFG.selected);
let chosen = [start.design, sv?.design].find(id => id && list().some(t => t.id === id)) || list()[0].id;
const current = () => tplById(chosen);
const opt = { n: start.n ?? sv?.n ?? QTYS[0], box: BOX_OFFERED && (start.box ?? sv?.box ?? false) };
let needTouched = !!start.need;

for (const k of Object.keys(C.fields)) if (start.f[k]) $(k).value = start.f[k];
if (start.need) $("need").value = start.need;

// o.f: kategorinin alanları; sample(): etiket ve 3D için boş alanlar örnek yazıyla dolu (o.text)
const data = () => ({ cat, design: chosen, f: Object.fromEntries(Object.keys(C.fields).map(k => [k, $(k).value.trim()])),
  ...opt, need: $("need").value });
const sample = (o, t) => ({ ...o, text: C.text(o.f, true, t) });   // t: kare çizilirken o kareye ait tasarım

const rows = (o, t) => C.rows(o.f)
  .concat([["Tasarım", designName(t.id)], ["Adet", `${o.n} adet${weight(o.n) ? ` (${weight(o.n)})` : ""}`]],
    BOX_OFFERED ? [["Sunum", o.box ? "Cam kutu" : "Kutusuz"]] : [],
    [["Elinizde olmalı", o.need ? niceShort(o.need) : "—"]]);

// Seçim tasarım/adet/kutu değişince paket yoksa en yakın olana geçilir; adres çubuğu ?variant= taşır (Shopify gibi)
function fitPack() { if (!pack(data())) { if (variantFor(chosen, opt.n, !opt.box)) opt.box = !opt.box;
    else opt.n = VARIANTS.find(v => v.design === chosen && v.box === opt.box)?.n ?? VARIANTS.find(v => v.design === chosen)?.n ?? opt.n; }
  const v = pack(data());
  if (v?.id) { const u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(history.state, "", u); } }

// ---- Çizim
// Tasarım kareleri (renk seçimi gibi): sadece görsel, seçilide koyu çerçeve ve köşede onay; adı başlıkta kalın
function drawDesigns() { const d = data(), l = list();
  $("designs").innerHTML = l.map(t => `<button class="cmm-design" type="button" data-id="${t.id}" aria-pressed="${t.id === chosen}" aria-label="${esc(designName(t.id))}: ${esc(t.desc)}" title="${esc(designName(t.id))}"><span class="cmm-design__img">${render(t, sample(d, t))}</span></button>`).join("");
  $("designName").textContent = designName(chosen); }

function drawTimeline(o) { const p = plan();
  if ($("timeline")) $("timeline").innerHTML = [
    ["Bugün", "Sipariş ve baskı onayı", nice(p.today)],
    [`${prodDays()} gün`, "Baskı ve hazırlık", `${niceShort(p.prodFrom)} – ${niceShort(p.shipOn)}`],
    ["Kargo", "Kargoya teslim", nice(p.shipOn)],
    [`1–${SHIP_DAYS} iş günü`, "Kapınızda", `en geç ${nice(p.arriveBy)}`],
  ].map(([k, t, d]) => `<li><span class="cmm-tl-k">${esc(k)}</span><span class="cmm-tl-t"><b>${esc(t)}</b><small>${esc(d)}</small></span></li>`).join("");
  // Teslim tarihi tek yerde: tarih alanının altında
  const n = $("needNote"); n.classList.remove("cmm-ok", "cmm-warn");
  if (!o.need) { n.textContent = `En erken ${nice(p.arriveBy)} elinizde olur.`; return; }
  if (o.need >= p.arriveBy) { n.classList.add("cmm-ok"); n.textContent = `✓ Yetişir: en geç ${nice(p.arriveBy)} elinizde.`; return; }
  n.classList.add("cmm-warn");
  n.textContent = `Bu tarihe yetiştiremiyoruz. En erken ${nice(p.arriveBy)}. Daha erken lazımsa bize yazın.`;
}

// Adet: her paket bir pill (adet + kargo dahil fiyat). Sunum: kutusuz / cam kutu (+fark).
$("qtys").innerHTML = QTYS.map(n => `<input type="radio" name="cmm-qty" id="cmm-qty-${n}" value="${n}">`
  + `<label for="cmm-qty-${n}"><span>${n} adet</span><small></small></label>`).join("");
const boxInputs = [...root.querySelectorAll('input[name="cmm-box"]')];

// Fiyat bloğu ödenecek toplamı gösterir (kargo dahil), altında adet başı fiyat
function drawOrder() { const o = data(), w = weight(o.n);
  $$("#cmm-qtys input").forEach(i => { const v = variantFor(o.design, +i.value, o.box);
    i.checked = +i.value === o.n; i.disabled = !v || (!v.available && !PREVIEW_ONLY);
    i.nextElementSibling.querySelector("small").textContent = v && v.price ? money(v.price + shipFor(v.price)) : ""; });
  $("qtyNote").innerHTML = `${w ? `= ${w} çikolata · ` : ""}${QTYS[QTYS.length - 1]} adetten fazlası için <a href="${esc(CFG.contactUrl)}">bize yazın</a>.`;
  const withBox = variantFor(o.design, o.n, true), noBox = variantFor(o.design, o.n, false);
  boxInputs.forEach(i => { const v = i.value === "1" ? withBox : noBox; i.checked = (i.value === "1") === o.box; i.disabled = !v || !v.available; });
  root.querySelector('label[for="cmm-box-1"]').textContent = withBox && noBox && withBox.price > noBox.price ? `Cam kutu +${money(withBox.price - noBox.price)}` : "Cam kutu";
  $("boxNote").textContent = withBox && !withBox.available ? "Cam kutu şu an stokta yok."
    : o.box ? "İsimler ve tarih kapağa altın harflerle yazılır." : "Sadece madlenler, kutusuz gönderilir.";
  $("need").min = earliest();
  drawTimeline(o);
  if ($("priceNow")) $("priceNow").textContent = money(total(o));
  $("mobileTotal").textContent = money(total(o));
  if (!o.box && view === "box") setView("madlen"); }

function drawPreview() { const o = data(), t = current();
  $("labelFront").innerHTML = render(t, sample(o));
  document.dispatchEvent(new Event("cmm:labelchange"));
  $("summary").innerHTML = rows(o, t).map(([k, v]) => `<dt>${k}</dt><dd>${esc(v)}</dd>`).join("")
    + priceLines(o).slice(-1).map(([k, v]) => `<dt>${esc(k)}</dt><dd>${v}</dd>`).join("")
    + `<dt class="cmm-sum">${TOTAL_LABEL}</dt><dd class="cmm-sum">${money(total(o))}</dd>`;
  if ($("thumb3d")) $("thumb3d").innerHTML = render(t, sample(o));
  $("chosenName").textContent = `${designName(t.id)} · ${o.n} adet`;
  drawReady(); }
const update = () => { syncNeed(); drawDesigns(); drawOrder(); drawPreview(); };

// Nişan: "Elinizde olmalı" alanı etkinlik gününün bir gün öncesini takip eder (kullanıcı değiştirene kadar)
function syncNeed() { const d = C.eventDate?.(data().f); if (!needTouched && C.eventDate) $("need").value = d ? addDays(d, -1) : ""; }

Object.values(CATS).forEach(c => { if ($(c.group)) $(c.group).hidden = c !== C; });
if (!BOX_OFFERED) $("boxField").hidden = true;

// Tasarım, adet ve sunum seçimi = paket (varyant) seçimi
$("designs").addEventListener("click", e => { const b = e.target.closest(".cmm-design"); if (!b) return;
  chosen = b.dataset.id; $$(".cmm-design").forEach(d => d.setAttribute("aria-pressed", d === b));
  $("designName").textContent = designName(chosen); showPhoto(""); fitPack(); drawOrder(); drawPreview(); });
$("qtys").addEventListener("change", e => { const i = e.target; if (!i.matches("input")) return;
  opt.n = +i.value; fitPack(); drawOrder(); drawPreview(); });
boxInputs.forEach(i => i.addEventListener("change", () => { opt.box = i.value === "1"; if (opt.box) setView("box"); fitPack(); drawOrder(); drawPreview(); }));
$("info").addEventListener("input", () => { update(); if (!$("err").hidden) validate(); });
$("info").addEventListener("submit", e => e.preventDefault());
$("need").addEventListener("input", () => { needTouched = true; drawOrder(); drawPreview(); if (!$("err").hidden) validate(); });

// ---- Kontrol
function clearErr() { $("err").hidden = true; [...C.required.map(r => r[0]), "need"].forEach(id => $(id).removeAttribute("aria-invalid")); }
function validate() { const o = data(), miss = C.required.filter(([id]) => !$(id).value.trim());
  const msgs = miss.length ? ["Lütfen doldurun: " + miss.map(m => m[1]).join(", ") + "."] : [];
  if (!o.need) { msgs.push("Kutunun en geç ne zaman elinizde olması gerektiğini seçin."); miss.push(["need"]); }
  else if (o.need < earliest()) { msgs.push($("needNote").textContent); miss.push(["need"]); }
  clearErr(); miss.forEach(([id]) => $(id).setAttribute("aria-invalid", "true"));
  $("err").hidden = !msgs.length; $("err").textContent = msgs.join(" ");
  return !msgs.length; }

// ---- Görünüm: kutu / tek madlen
let view = opt.box ? "box" : "madlen";
function setView(v) { view = v; CM.view = v;
  $$(".cmm-seg button").forEach(b => b.setAttribute("aria-pressed", b.dataset.view === v));
  $("gl").setAttribute("aria-label", v === "box" ? "Cam kutu 3D ön izleme" : "Madlen 3D ön izleme");
  document.dispatchEvent(new Event("cmm:viewchange")); }
// Ön izlemede "Kutu" cam kutuyu seçer (Sunum da değişir); "Madlen" sadece görünüm
$$(".cmm-seg button").forEach(b => b.addEventListener("click", () => {
  if (b.dataset.view === "box" && !opt.box) { if (!variantFor(chosen, opt.n, true)) return; opt.box = true; fitPack(); drawOrder(); drawPreview(); }
  setView(b.dataset.view); }));

// Küçük resimler: 3D ön izleme ya da ürün görseli (sahnenin üstünde)
function showPhoto(src, alt = "") { const img = $("photo");
  img.hidden = !src; $("stage").classList.toggle("photo", !!src); if (src) { img.src = src; img.alt = alt; }
  $$(".cmm-thumb").forEach(b => b.setAttribute("aria-current", String(b.dataset.photo === src))); }
$$(".cmm-thumb").forEach(b => b.addEventListener("click", () => showPhoto(b.dataset.photo, b.dataset.alt)));


// ---- Paylaşım
$("share").onclick = async () => { const url = shareUrl(data()), note = $("shareNote");
  if (navigator.share) { try { await navigator.share({ title: "Madlen tasarımımız", text: "Chocomoys madlen kutumuzun tasarımına bakar mısın?", url }); return; } catch (e) { if (e.name === "AbortError") return; } }
  try { await navigator.clipboard.writeText(url); note.textContent = "Bağlantı kopyalandı. WhatsApp'ta yapıştırıp gönderebilirsiniz."; }
  catch (e) { note.textContent = url; } };

// ---- Sipariş: onay penceresi → sepet (çekmece açılır) → Shopify ödeme
// Seçilen paket (varyant) satışta olmalı
const ready = () => !!(pack(data())?.id && pack(data()).available);
const addButtons = ["finish", "stickyAdd", "sheetAdd"].map($).filter(Boolean);
const NOT_READY = "Sipariş şu anda alınamıyor. Lütfen daha sonra tekrar deneyin.";
function drawReady() { const ok = ready(); addButtons.forEach(b => { b.disabled = !ok; });
  if (!ok) $("shareNote").textContent = NOT_READY; else if ($("shareNote").textContent === NOT_READY) $("shareNote").textContent = ""; }
const message = (o, t) => `Chocomoys isme özel madlen\n\n` + rows(o, t).map(([k, v]) => `${k}: ${v}`).join("\n")
  + `\n\nAdet fiyatı: ${money(unit(o))}\n` + priceLines(o).map(([k, v]) => `${k}: ${v}`).join("\n") + `\n${TOTAL_LABEL}: ${money(total(o))}`;

function finish() { if (!validate()) { closePreview(); const f = root.querySelector('[aria-invalid="true"]'); f?.scrollIntoView({ block: "center" }); f?.focus({ preventScroll: true }); return; }
  const o = data(), t = current();
  $("dialogPreview").innerHTML = render(t, sample(o));
  $("msg").textContent = message(o, t); $("copy").textContent = "Özeti kopyala";
  $("approve").checked = false; $("send").disabled = true; $("send").textContent = "Sepete ekle";
  $("sendNote").textContent = "Teslimat adresi ve ödeme bir sonraki adımda.";
  closePreview(); $("done").showModal(); }
addButtons.forEach(b => { b.onclick = finish; });
$("approve").onchange = () => { $("send").disabled = !$("approve").checked; };

// Dawn'ın ürün formu gibi: çekmece bölümleri yanıtla birlikte istenir, çekmece açılır.
// Tek satır: paket varyantı × 1. İsimler, tarih ve teslim tarihi görünür özellik; tasarım linki ve onay zamanı gizli (_).
const cartPost = (url, body) => fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) })
  .then(async r => { const j = await r.json().catch(() => ({})); if (!r.ok || j.status) throw new Error(j.description || j.message || `Hata ${r.status}`); return j; });
async function addToCart(o) {
  const routes = window.routes || {}, v = pack(o);
  const cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification");
  const props = Object.fromEntries(Object.entries(C.props(o.f))
    .concat([["Teslim tarihi (en geç)", fmtDate(o.need)], ["_Tasarım linki", shareUrl(o)], ["_Onay", o.ok]])
    .filter(([, val]) => val));
  const body = { items: [{ id: +v.id, quantity: 1, properties: props }] };
  if (cart) { body.sections = cart.getSectionsToRender().map(s => s.id); body.sections_url = location.pathname; }
  const res = await cartPost(`${routes.cart_add_url || "/cart/add"}.js`, body);
  if (!cart) { location.href = routes.cart_url || "/cart"; return; }
  if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") publish(PUB_SUB_EVENTS.cartUpdate, { source: "cm-madlen", productVariantId: v.id, cartData: res });
  $("done").close();
  cart.renderContents({ ...res, id: v.id });
}

$("orderForm").addEventListener("submit", async e => { e.preventDefault(); if (!$("approve").checked || !ready()) return;
  const o = { ...data(), ok: new Date().toLocaleString("sv-SE").slice(0, 16) };
  $("send").disabled = true; $("send").textContent = "Ekleniyor…";
  try { await addToCart(o); $("send").textContent = "Sepete ekle"; }
  catch (err) { $("send").disabled = false; $("send").textContent = "Sepete ekle";
    $("sendNote").textContent = `Sepete eklenemedi (${err.message}). Lütfen tekrar deneyin.`; } });
$("copy").onclick = async () => { const txt = $("msg").textContent + `\n\nTasarım linki: ${shareUrl(data())}`;
  try { await navigator.clipboard.writeText(txt); $("copy").textContent = "Kopyalandı"; } catch (e) { const r = document.createRange(); r.selectNodeContents($("msg")); const s = getSelection(); s.removeAllRanges(); s.addRange(r); $("copy").textContent = "Metni seçtim, kopyalayın"; } };
$("close").onclick = () => $("done").close();
$("done").addEventListener("click", e => { if (e.target === $("done")) $("done").close(); });

// ---- Mobil: ön izleme tam ekran (geri tuşu da kapatır). Galeri yeri boş kalmasın diye yüksekliği tutulur.
const mobile = matchMedia("(max-width: 749px)");
const mediaWrap = $("preview").parentElement;
function openPreview() { if ($("preview").classList.contains("open")) return;
  mediaWrap.style.minHeight = `${mediaWrap.offsetHeight}px`; showPhoto("");
  $("preview").classList.add("open"); document.body.classList.add("cmm-preview-open"); $("preview").scrollTop = 0;
  history.pushState({ cmmPreview: true }, ""); $("closePreview").focus(); }
function closePreview(fromHistory) { if (!$("preview").classList.contains("open")) return;
  $("preview").classList.remove("open"); document.body.classList.remove("cmm-preview-open"); mediaWrap.style.minHeight = "";
  if (!fromHistory && history.state?.cmmPreview) history.back(); $("openPreview").focus(); }
$("openPreview").onclick = openPreview;
$("closePreview").onclick = () => closePreview();
addEventListener("popstate", () => closePreview(true));
addEventListener("keydown", e => { if (e.key === "Escape" && !$("done").open) closePreview(); });
mobile.addEventListener("change", () => { if (!mobile.matches) closePreview(); });

// Mobil sabit çubuk: ön izleme ve "Sepete ekle" ekranda değilken görünür (diğer ürün sayfalarındaki gibi)
const inView = new Map();
const stickyIO = new IntersectionObserver(es => { es.forEach(e => inView.set(e.target, e.isIntersecting));
  $("sticky").classList.toggle("visible", ![...inView.values()].some(Boolean)); });
[$("stage"), $("finish")].forEach(el => stickyIO.observe(el));

update(); setView(view);

// ---- 3D için durum ve döndürme (çizim: cm-madlen-3d.js). Hafifçe salınır, sürükleyerek çevrilir; açı sınırlı.
CM.labelState = () => ({ t: current(), o: sample(data()) });
CM.lidLines = lidLines;
CM.rot = { rx: 10, ry: -20 };
document.dispatchEvent(new Event("cmm:labelchange"));
(() => { const stage = $("stage"), rot = CM.rot;
  const still = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  let drag = null, idleAt = 0; const t0 = performance.now();
  stage.addEventListener("pointerdown", e => { drag = { x: e.clientX, y: e.clientY, rx: rot.rx, ry: rot.ry }; stage.setPointerCapture(e.pointerId); stage.classList.add("dragging"); });
  stage.addEventListener("pointermove", e => { if (!drag) return; if (e.pointerType === "mouse" && !e.buttons) return end();
    rot.ry = clamp(drag.ry + (e.clientX - drag.x) * .45, -55, 55); rot.rx = clamp(drag.rx + (e.clientY - drag.y) * .35, -35, 40); });
  function end() { if (!drag) return; drag = null; stage.classList.remove("dragging"); idleAt = performance.now() + 2500; }
  ["pointerup", "pointercancel", "lostpointercapture"].forEach(ev => stage.addEventListener(ev, end));
  if (still) return;
  const tick = now => { if (!drag && now > idleAt) { const k = (now - t0) / 1000;
      const tx = 10 + 4 * Math.sin(k * .7), ty = -18 + 16 * Math.sin(k * .5);
      rot.rx += (tx - rot.rx) * .04; rot.ry += (ty - rot.ry) * .04; }
    requestAnimationFrame(tick); };
  requestAnimationFrame(tick);
})();
})();
